import altimeterImage from "../images/altimeter.com.png";
import bumlistImage from "../images/bumlist.jpg";
import footbookingImage from "../images/footbooking.jpg";
import aiTravelerImage from '../images/aitravel.jpg';
import terraceshopImage from '../images/terrace.jpg';
import connect4Image from '../images/connect-4.jpg';
import rockScissorsImage from '../images/rock-scissor.png'
import bossCat from '../images/bosscat.webp';
import myThinkCap from '../images/mythink.webp';
import chaparralImage from '../images/chaparral_labs.jpg';

export const projects = [
  {
    id: 100,
    title: "Chaparral Labs",
    img: chaparralImage,
    type: "product",
    stack: "React | TypeScript | Python | Rust | Axum | CockroachDB | AWS | CDK | Docker | CI/CD",
    about: [
      "A Monolithic(Developed) and cloud-based(Under Development) proteomics research and analytics platform for scientists and a multi-tenant business intelligence suite for corporate clients.",
      "Built with React, TypeScript, Python, Rust, Axum, CockroachDB, AWS, CDK, Docker, and CI/CD."
    ],
    link: "https://www.chaparral.ai/",
    page: "/chaparral.ai",
  },
  {
    id: 102,
    title: "MyThinkingCap",
    img: myThinkCap,
    type: "product",
    stack: "React | TypeScript | Node.js | Express | MongoDB | Mongoose | Docker | CI/CD",
    about: [
      "A thoughtful application designed to enhance productivity and streamline workflows."
    ],
    link: "https://mythinkingcap.ai/",
    page: "/mythinkcap.ai",
  },
  {
    id: 101,
    title: "BossCat(PunchListUSA)",
    img: bossCat,
    stack: "Next.js | React | TypeScript | Node.js | Python | PostgreSQL | Prisma | Docker | CI/CD",
    type: "product",
    about: [
      "A comprehensive home repair, renovation & maintenance solution platform.",
      "Your one-stop solution for home improvements with instant inspection estimates nationwide."
    ],
    link: "https://www.bosscathome.com/",
    page: "/bosscat.com",
  },
  {
    id: 1,
    title: "Altimeter.co",
    img: altimeterImage,
    type: "demo",

    stack: "React | React-Flow | Tailwind CSS | Vercel | Custom CSS | HTML5 | CSS3",
    about: [
      "Company Webpage for Node-Based Animated Single-Screen Fully Responsible"
    ],
    link: "https://altimeter-site-102125.vercel.app/",
    page: "/altimeter.co",
  },
  {
    id: 3,
    title: "Bumlist management",
    img: bumlistImage,
    stack: "Next.js | Tailwind CSS | Vercel | Custom CSS | HTML5 | CSS3 | Supabase",
    type: "demo",

    about: [
      "Event creation and management (baby showers, birthdays, weddings, etc.)", 
      "Gift list management with priority marking Public registry sharing via unique URLs and QR codes.",
    ],
    link: "https://bumlist-management.vercel.app/",
    page: "/bumlist-management",
  },
  {
    id: 2,
    title: "FootBooking",
    img: footbookingImage,
    stack: "Next.js | Better Auth | Tailwind CSS | Vercel | Custom CSS | HTML5 | CSS3 | Shadcn UI | Prisma | PostgreSQL",
    type: "demo",

    about: [
      "Football pitch reservation app built with Next.js, Shadcn UI, Prisma, and Better Auth.", 
    ],
    link: "https://footbookr.vercel.app/",
    page: "/foot-pitch-booking",
  },
  {
    id: 6,
    title: "AI Travel Planner",
    img: aiTravelerImage,
    stack: "Next.js | Boostrap | OpenAI | Clerk",
    type: "demo",

    about: [
      "A modern travel planner using Next.js, TailwindCSS, Prisma, Open AI, and Clerk.", 
    ],
    link: "https://travelplan-sm.vercel.app/",
    page: "/travel-planner",
  },
  {
    id: 4,
    title: "Terrace Shop",
    img: terraceshopImage,
    stack: "Next.js | Bootstrap | Shopify API | Tailwind CSS | Vercel",
    type: "demo",

    about: [
      "A custom online store built with Next.js and Shopify. It lets users browse products, add items to a cart, and log in to see their orders."
    ],
    link: "https://terraceshop.vercel.app/",
    page: "/terrace-shop",
  },
  // {
  //   id: 5,
  //   title: "Tesla Clone",
  //   img: teslaImage,
  //   stack: "React | Styled Components",
    // type: "demo",

  //   about: [
  //     "A tesla home page clone showing Styled Components usage."
  //   ],
  //   link: "https://tesla-clone-roimalka.netlify.app",
  //   page: "/tesla-clone",
  // },
  {
    id: 15,
    title: "4 Connection",
    img: connect4Image,
    stack: "React | Styled Components | SCSS",
    type: "demo",

    about: [
      "A Fancy game connecting 4 balls.",
      "Human VS Human",
      "Human VS Bot",
    ],
    link: "https://connection4-react.vercel.app/",
    page: "/connect-4",
  },
  {
    id: 35,
    title: "Rock-Paper-Scissors Game",
    img: rockScissorsImage,
    stack: "React | Styled Components | SCSS",
    type: "demo",

    about: [
      "A fancy game playing Rock-Paper-Scissors."
    ],
    link: "https://rock-paper-scissors-play-xi.vercel.app/",
    page: "/rock-paper-scissors",
  },
];
